import script from "./AccountIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountIntegration.vue?vue&type=script&setup=true&lang=js"

import "./AccountIntegration.vue?vue&type=style&index=0&id=4a0c1887&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0c1887"]])

export default __exports__